// In JavaScript, a debounce function makes sure that your code is only triggered once per user input.
// Search box suggestions, text-field auto-saves, and eliminating double-button clicks are all use cases for debounce.
// This variant fires once after the last input and the timeout has expired.
// Loosely based on: https://www.freecodecamp.org/news/javascript-debounce-example/
//
// Per-instance: each caller owns a `Debouncer`, so unrelated callers (e.g. a Dynamic Table search
// and that same table's selection-change dispatch, or a searchable select on the same page) never
// cancel each other's pending callback through a shared module-level timer.

export class Debouncer {
   private timer: ReturnType<typeof setTimeout> | undefined

   run(delay: number, callback: () => void): void {
      this.cancel()
      this.timer = setTimeout(() => {
         this.timer = undefined
         callback()
      }, delay)
   }

   cancel(): void {
      if (this.timer !== undefined) {
         clearTimeout(this.timer)
         this.timer = undefined
      }
   }
}
